import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const SaveIcon = (props: SvgComponentProps) => {
  const { width, height, color, onClick } = props;

  return (
    <SvgWrapper onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M1.43555 0H18.5645C19.3574 0 20 0.657648 20 1.44784V18.5522C20 19.3416 19.3566 20 18.5645 20H3.83906C3.72617 20 3.62422 19.9543 3.55039 19.8804L0.119532 16.4459C0.0815657 16.4081 0.0514565 16.3631 0.030941 16.3136C0.0104256 16.264 -9.01332e-05 16.2109 5.81953e-07 16.1573V1.44784C5.81953e-07 0.657257 0.642579 0 1.43555 0ZM6.81641 17.5082C6.2793 17.5082 6.2793 16.691 6.81641 16.691H12.8309C13.3676 16.691 13.3676 17.5082 12.8309 17.5082H6.81641ZM6.81641 14.991C6.2793 14.991 6.2793 14.1738 6.81641 14.1738H12.8309C13.3676 14.1738 13.3676 14.991 12.8309 14.991H6.81641ZM15.0004 19.1711V13.6945C15.0004 13.0384 14.4586 12.4965 13.8031 12.4965H5.84375C5.18828 12.4965 4.64688 13.0384 4.64688 13.6945V19.1711H15.0004ZM15.8164 13.6945V19.1828H18.5645C18.9102 19.1828 19.1836 18.8947 19.1836 18.5522V1.44784C19.1836 1.10455 18.9105 0.817172 18.5645 0.817172H15.8164V7.47068C15.8164 8.57757 14.909 9.48624 13.8031 9.48624H5.84375C4.73672 9.48624 3.83047 8.57875 3.83047 7.47068V0.817172H1.43555C1.08906 0.817172 0.816407 1.10416 0.816407 1.44784V15.988L3.83047 19.0049V13.6945C3.83047 12.5872 4.7375 11.6793 5.84375 11.6793H13.8031C14.9055 11.6793 15.8164 12.5911 15.8164 13.6945ZM15.0004 7.47068V0.817172H4.64688V7.47068C4.64688 8.12754 5.18789 8.66907 5.84375 8.66907H13.8031C14.4582 8.66907 15.0004 8.12637 15.0004 7.47068Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};

export default SaveIcon;
